module.exports = __webpack_public_path__ + "9f00a7d8eafa6f593713c1c4b255d84f.svg";